import React from 'react';
import { MessageSquareCode, Lightbulb, Wand2 } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const ForHobbyists: React.FC = () => {
  return (
    <section id="for-hobbyists" className="bg-background py-16 md:py-24">
      <Container>
        <div className="grid gap-12 md:grid-cols-2 md:items-center">
          <div className="order-2 md:order-1">
            <div className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary ring-1 ring-inset ring-primary/20 mb-4">
              <Lightbulb size={16} className="mr-1" />
              <span>For Citizen Developers</span>
            </div>
            
            <h2 className="mb-6 text-3xl font-bold sm:text-4xl">
              Turn Your Game Ideas Into Reality — Without Coding
            </h2>
            
            <p className="mb-6 text-lg text-muted-foreground">
              With Wizantix.games, anyone can become a game developer. No programming knowledge required. Just describe your game idea, and our AI will generate a playable prototype instantly.
            </p>
            
            <ul className="mb-8 space-y-4">
              {[
                {
                  icon: <MessageSquareCode className="h-5 w-5 text-primary" />,
                  text: 'Describe your game in plain English and watch AI generate it',
                },
                {
                  icon: <Wand2 className="h-5 w-5 text-primary" />,
                  text: 'Use our no-code editor to customize and refine your game',
                },
                {
                  icon: <Lightbulb className="h-5 w-5 text-primary" />,
                  text: 'Get AI suggestions for gameplay improvements and features',
                },
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <div className="mr-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary/10">
                    {item.icon}
                  </div>
                  <span className="text-foreground">{item.text}</span>
                </li>
              ))}
            </ul>
            
            <Button>Start Creating</Button>
          </div>
          
          <div className="order-1 md:order-2">
            <div className="relative">
              <div className="absolute -inset-1 rounded-xl bg-gradient-to-r from-primary/20 to-secondary/20 opacity-70 blur-xl"></div>
              <div className="relative rounded-xl border border-border bg-card p-2 shadow-xl">
                <img
                  src="https://images.pexels.com/photos/1174746/pexels-photo-1174746.jpeg"
                  alt="Creative workspace"
                  className="rounded-lg w-full"
                  width={600}
                  height={400}
                />
              </div>
              
              <div className="absolute -bottom-24 -right-6 space-y-3">
                <div className="rounded-xl border border-border bg-card p-4 shadow-lg">
                  <div className="flex items-center space-x-3 text-sm">
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-white">
                      <MessageSquareCode size={16} />
                    </div>
                    <div className="max-w-[220px]">
                      <p className="font-medium text-foreground">
                        "Create a 2D platformer with a robot character"
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="rounded-xl border border-border bg-card p-4 shadow-lg">
                  <div className="flex items-center space-x-3 text-sm">
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary text-white">
                      <Wand2 size={16} />
                    </div>
                    <div className="max-w-[220px]">
                      <p className="font-medium text-foreground">
                        "Add power-ups and special abilities"
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="rounded-xl border border-border bg-card p-4 shadow-lg">
                  <div className="flex items-center space-x-3 text-sm">
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-accent text-white">
                      <Lightbulb size={16} />
                    </div>
                    <div className="max-w-[220px]">
                      <p className="font-medium text-foreground">
                        "Generate a challenging level design"
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ForHobbyists;